import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { REST_BASE_URL } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {

  private _envConfig$: BehaviorSubject<EnvironmentConfig> = new BehaviorSubject(null);

  constructor(private _httpClient: HttpClient) {}

  fetchEnvConfig() {
    return this._httpClient.get<EnvironmentConfig>(`${ REST_BASE_URL }/visa-env-config`)
    .pipe(map(value => {
      this._envConfig$.next(value);
      return value;
    }));
  }

  getEnvConfig() {
    return this._envConfig$.value;
  }
}

export interface EnvironmentConfig {
  clientCooldownTimer: string;
  captchaEnabled?: boolean;
  siteKey?: string;
  captchaSolutionCacheDurationHours?: number;
}
